import React, { useEffect } from 'react';
import NavMenu from './nav/NavMenu';
import { Box } from '@mui/material';
import ReAuthDialog from './ReAuthDialog';
import PromptModal from './promptModal';
import Footer from './Footer';
import { useTheme } from '@emotion/react';
import ErrorModal from './errorModal';
import useLiteratureCurrentView from './nav/hooks/useLiteratureCurrentView';

export default function Layout({ children }) {
  const theme = useTheme();
  const { isInLiteratureView, isInMaintenanceCalculator } = useLiteratureCurrentView();

  useEffect(() => {
    const bodyElement = document.getElementsByTagName('body')[0];
    if (isInMaintenanceCalculator) {
      bodyElement.classList.add('calculatorPage');
    } else if (!isInMaintenanceCalculator && bodyElement.classList.contains('calculatorPage')) {
      bodyElement.classList.remove('calculatorPage');
    }
  }, [isInMaintenanceCalculator]);

  let headerHeight = theme.appBar.height;
  let boxHeight = `calc(100vh - ${headerHeight}px)`;
  if (!isInLiteratureView) {
    headerHeight = 82;
    boxHeight = `calc(100vh - ${headerHeight}px - 5em)`;
  }
  if (isInMaintenanceCalculator) {
    headerHeight = 0;
    boxHeight = `calc(100vh - ${headerHeight}px)`;
  }

  return (
    <>
      <NavMenu />
      <Box sx={{
        display: 'flex',
        height: boxHeight,
        top: `${headerHeight}px`,
        left: 0,
        width: '100vw',
        position: 'fixed'
      }} className={isInMaintenanceCalculator ? 'calculatorPageBox' : ''}>
        {children}
      </Box>
      <ReAuthDialog />
      <PromptModal />
      <ErrorModal />
      {!isInLiteratureView ? <Footer /> : null}
    </>
  );
}